module.exports = __webpack_public_path__ + "static/media/clip.c6df69e9.jpg";